import { SupportedLanguageSchema } from '@geartracker/types';

import { RegisterEmailDto } from './auth';
import { createZodDto } from './zod';

import { z } from 'zod';

const createOrganizationSchema = z.object({
  registerData: RegisterEmailDto.schema,
  organizationName: z.string().min(1).max(255).optional(),
  user: z.object({
    firstName: z.string().min(1).max(255).optional(),
    lastName: z.string().min(1).max(255).optional(),
  }),
  organization: z.object({
    name: z.string().min(1).max(255).optional(),
  }),
});

export class CreateOrganizationSchema extends createZodDto(
  createOrganizationSchema,
) {}

const adminUpdateOrganizationSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  plan: z.enum(['FREE', 'PRO', 'STARTER', 'PREMIUM', 'CUSTOM']).optional(),
  planState: z.enum(['TRIAL', 'ACTIVE']).optional(),
  equipmentLimit: z.number().int().positive().nullable().optional(),
  industry: z.string().max(200).nullable().optional(),
});

export class AdminUpdateOrganizationDto extends createZodDto(
  adminUpdateOrganizationSchema,
) {}

const adminUpdateUserSchema = z.object({
  firstName: z.string().min(1).max(200).optional(),
  lastName: z.string().min(1).max(200).optional(),
  email: z.email().nullable().optional(),
  role: z
    .enum([
      'ADMIN',
      'MANAGER',
      'EDITOR',
      'REVIEWER',
      'READER',
      'HOLDER',
      'NONE',
    ])
    .optional(),
  activationStatus: z
    .enum(['ACTIVE', 'PENDING', 'NO_ACCOUNT', 'DEACTIVATED'])
    .optional(),
  isDeactivated: z.boolean().optional(),
});

export class AdminUpdateUserDto extends createZodDto(adminUpdateUserSchema) {}

const adminSendNewsletterSchema = z.object({
  language: SupportedLanguageSchema,
  subject: z.string().min(1).max(200),
  htmlContent: z.string().min(1),
  target: z.enum(['everyone', 'admins']),
  organizationId: z.number().int().positive().nullable().optional(),
  testOnly: z.boolean().optional(),
});

export class AdminSendNewsletterDto extends createZodDto(
  adminSendNewsletterSchema,
) {}
